import React from "react";
import { Box, Modal, Fade } from "@mui/material";

// Shared centered-card shell for the "detail drawer" popups across the app
// (staff, students, users, schools) — replaces the old anchor="right"
// sliding Drawer pattern. Each caller keeps its own header/content/dialog
// JSX exactly as before; this only changes the outer container from a
// full-height side panel to a bounded, centered card with its own scroll.
export default function CenteredDetailModal({ open, onClose, children, maxWidth = 560 }) {
  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Fade in={open} timeout={200}>
        <Box
          sx={{
            position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            width: `min(94vw, ${maxWidth}px)`, maxHeight: "88vh",
            display: "flex", flexDirection: "column",
            backgroundColor: "#ffffff", borderRadius: "18px",
            boxShadow: "0 12px 48px rgba(0,0,0,0.18)",
            overflow: "hidden", outline: "none",
          }}
        >
          {children}
        </Box>
      </Fade>
    </Modal>
  );
}
